import useMediaQuery from 'usehooks-ts/dist/esm/useMediaQuery/useMediaQuery'

export default function useMobileMediaQuery() {
  return useMediaQuery(`(min-width: ${0}px) and (max-width: ${766}px) `)
}
